import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2C3329] text-[#FDFBF7] py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-[#D97757] rounded-full flex items-center justify-center">
                <Home className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading font-semibold text-xl">NeighborBorrow</span>
            </div>
            <p className="text-[#FDFBF7]/70 mb-4 max-w-md">
              Borrow what you need, lend what you don't. Building stronger communities one item at a time.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-[#FDFBF7]/60 hover:text-[#D97757] transition-colors">
                <Mail className="w-5 h-5" />
              </a>
              <a href="#" className="text-[#FDFBF7]/60 hover:text-[#D97757] transition-colors">
                <Phone className="w-5 h-5" />
              </a>
              <a href="#" className="text-[#FDFBF7]/60 hover:text-[#D97757] transition-colors">
                <MapPin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/browse" className="text-[#FDFBF7]/70 hover:text-[#D97757] transition-colors">
                  Browse Items
                </Link>
              </li>
              <li>
                <Link to="/list-item" className="text-[#FDFBF7]/70 hover:text-[#D97757] transition-colors">
                  List an Item
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-[#FDFBF7]/70 hover:text-[#D97757] transition-colors">
                  My Dashboard
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Categories</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/browse?category=Tools" className="text-[#FDFBF7]/70 hover:text-[#D97757] transition-colors">
                  Tools
                </Link>
              </li>
              <li>
                <Link to="/browse?category=Electronics" className="text-[#FDFBF7]/70 hover:text-[#D97757] transition-colors">
                  Electronics
                </Link>
              </li>
              <li>
                <Link to="/browse?category=Sports" className="text-[#FDFBF7]/70 hover:text-[#D97757] transition-colors">
                  Sports
                </Link>
              </li>
              <li>
                <Link to="/browse?category=Outdoors" className="text-[#FDFBF7]/70 hover:text-[#D97757] transition-colors">
                  Outdoors
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#FDFBF7]/10 mt-10 pt-8 text-center text-[#FDFBF7]/50 text-sm">
          <p>&copy; {new Date().getFullYear()} NeighborBorrow. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
